export default __webpack_public_path__ + "static/media/logo.4e6a56e0.png";